import clsx from "clsx";
import React from "react";
import styles from "./DiscountChip.module.scss";
import { Icon } from "../Icon/Icon";
import { BackgroundColor, classForBackground } from "../Backgrounds/background";

interface DiscountChipProps {
  background: BackgroundColor;
  className?: string;
  lineThrough: boolean;
}

export const DiscountChip: React.FC<
  React.PropsWithChildren<DiscountChipProps>
> = ({ children, className, background, lineThrough }) => {
  const bgClass = classForBackground(background);

  return (
    <div
      className={clsx(styles.chip, bgClass, className, {
        [styles.withLineThrough]: lineThrough
      })}
    >
      <Icon
        name="discount-chip"
        size="1x"
        padding={false}
        className={styles.icon}
      />
      {children}
    </div>
  );
};
